import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

const FREQS = [
  { v: "monthly", l: "Monthly" }, { v: "quarterly", l: "Quarterly" },
  { v: "half_yearly", l: "Half-Yearly" }, { v: "yearly", l: "Yearly" },
];

export default function AgentAddCustomer() {
  const nav = useNavigate();
  const [c, setC] = useState({ full_name: "", phone: "", aadhaar: "", pan: "", address: "", nominee_name: "" });
  const [p, setP] = useState({ policy_number: "", policy_name: "", premium_amount: "", frequency: "yearly", start_date: "", due_date: "" });
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!c.full_name || !c.phone) { toast.error("Name & phone required"); return; }
    setLoading(true);
    try {
      const cust = await api.post("/agent/customers", c);
      if (p.policy_number && p.premium_amount) {
        await api.post("/admin/policies", {
          ...p,
          customer_id: cust.data.id,
          premium_amount: parseFloat(p.premium_amount),
        });
      }
      toast.success("Customer added!");
      nav("/agent/customers");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="agent-add-customer-page">
      <h1 className="text-2xl font-extrabold tracking-tight">Add Customer</h1>
      <p className="text-sm text-slate-500">Register a new customer & optionally create their policy</p>

      <div className="mt-5 bg-white border border-slate-100 rounded-2xl p-5 card-shadow space-y-3 max-w-2xl">
        <h3 className="font-bold">Customer Details</h3>
        <div className="grid sm:grid-cols-2 gap-3">
          <F label="Full Name" testId="ac-name" v={c.full_name} set={(v) => setC({ ...c, full_name: v })} />
          <F label="Mobile Number" testId="ac-phone" v={c.phone} set={(v) => setC({ ...c, phone: v.replace(/\D/g, "") })} />
          <F label="Aadhaar" testId="ac-aadhaar" v={c.aadhaar} set={(v) => setC({ ...c, aadhaar: v })} />
          <F label="PAN" testId="ac-pan" v={c.pan} set={(v) => setC({ ...c, pan: v.toUpperCase() })} />
          <F label="Address" testId="ac-address" v={c.address} set={(v) => setC({ ...c, address: v })} />
          <F label="Nominee" testId="ac-nominee" v={c.nominee_name} set={(v) => setC({ ...c, nominee_name: v })} />
        </div>

        <h3 className="font-bold pt-3 mt-2 border-t border-slate-100">Policy Details (Optional)</h3>
        <div className="grid sm:grid-cols-2 gap-3">
          <F label="Policy Number" testId="ac-policy-number" v={p.policy_number} set={(v) => setP({ ...p, policy_number: v })} />
          <F label="Policy Name" testId="ac-policy-name" v={p.policy_name} set={(v) => setP({ ...p, policy_name: v })} />
          <F label="Premium Amount" testId="ac-premium" v={p.premium_amount} set={(v) => setP({ ...p, premium_amount: v.replace(/[^\d.]/g, "") })} />
          <div>
            <label className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500">Frequency</label>
            <select data-testid="ac-frequency" value={p.frequency} onChange={(e) => setP({ ...p, frequency: e.target.value })} className="mt-1.5 w-full border-2 border-slate-200 rounded-xl px-3 py-2.5 outline-none">
              {FREQS.map((f) => <option key={f.v} value={f.v}>{f.l}</option>)}
            </select>
          </div>
          <F label="Start Date" testId="ac-start" v={p.start_date} set={(v) => setP({ ...p, start_date: v })} type="date" />
          <F label="Due Date" testId="ac-due" v={p.due_date} set={(v) => setP({ ...p, due_date: v })} type="date" />
        </div>

        <button data-testid="save-customer" onClick={submit} disabled={loading} className="w-full mt-4 bg-tenant-primary text-white py-3.5 rounded-2xl font-bold tap-scale disabled:opacity-60">
          {loading ? "Saving..." : "Save Customer"}
        </button>
      </div>
    </div>
  );
}

const F = ({ label, testId, v, set, type = "text" }) => (
  <div>
    <label className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500">{label}</label>
    <input type={type} data-testid={testId} value={v} onChange={(e) => set(e.target.value)} className="mt-1.5 w-full border-2 border-slate-200 rounded-xl px-3 py-2.5 outline-none focus:border-tenant-primary" />
  </div>
);
